// import { SITE_URL_ONLY_DOMAIN } from '@/constants/siteUrl';

// 로그인 페이지 호출
const socialOpen = (url: string) => {
	window.location.href = url;
};

//애플 소셜로그인
export const socialLoginApple = () => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick && window.masterpick.nativeSocialAppleSignIn)
		window.masterpick.nativeSocialAppleSignIn();
	else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.nativeSocialGoogleSignIn
	)
		window.webkit?.messageHandlers.nativeSocialAppleSignIn.postMessage('');
	//else alert('지원하지 않는 환경입니다.');
	else socialOpen(`${import.meta.env.VITE_SOCIAL_API_URL}/api/apple/signin`);
};

//구글 소셜로그인
export const socialLoginGoogle = () => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick && window.masterpick.nativeSocialGoogleSignIn) {
		window.masterpick.nativeSocialGoogleSignIn();
	} else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.nativeSocialGoogleSignIn
	) {
		window.webkit?.messageHandlers.nativeSocialGoogleSignIn.postMessage('');
	}
	//else alert('지원하지 않는 환경입니다.');
	else {
		socialOpen(`${import.meta.env.VITE_SOCIAL_API_URL}/api/google/signin`);
	}
};
